// The task form asks two simple questions instead of showing roles:
//   1. Is this task for me, or for other people?
//   2. If for others: who are they, and who confirms it's done (me or one of them)?
// These helpers turn those answers into the roles the server stores, and back.

export const initialSharing = (task) => {
  if (!task || task.members.length <= 1) return { audience: "me", people: [], adminWho: "me" };

  const owner = task.members.find((m) => m.username === task.ownerName);
  const others = task.members.filter((m) => m.username !== task.ownerName);
  const otherAdmin = others.find((m) => m.role === "admin");
  return {
    audience: "others",
    people: others.map((m) => m.username),
    adminWho: owner && owner.role === "admin" ? "me" : (otherAdmin || others[0]).username,
  };
};

// Returns { myRole, members } as the server expects. Whoever confirms is the admin;
// everyone else is a doer who just taps "I've done it".
export const sharingBody = ({ audience, people, adminWho }) => {
  if (audience === "me" || people.length === 0) return { myRole: "admin", members: [] };
  if (adminWho === "me" || !people.includes(adminWho)) {
    return { myRole: "admin", members: people.map((username) => ({ username, role: "doer" })) };
  }
  return {
    myRole: "doer",
    members: people.map((username) => ({ username, role: username === adminWho ? "admin" : "doer" })),
  };
};
